const SERVICE_LABELS: Record<string, string> = {
  platform: "feature flags/platform",
};

function serviceSubject(service?: string): string {
  if (!service) return "This service";
  return `The ${SERVICE_LABELS[service] ?? service.replace(/-/g, " ")} service`;
}

export function serviceRetryingMessage(service?: string): string {
  return `${serviceSubject(service)} is temporarily unavailable. Retrying…`;
}

export function serviceUnavailableMessage(service?: string): string {
  return `${serviceSubject(service)} is temporarily unavailable, please try again shortly.`;
}
